/**
 * @file
 * SystemMessages class.
 */

import ComponentBase from '../../core/component-base';

/**
 * The SystemMessages class makes Drupal's system messages dismissable.
 */
export default class SystemMessages extends ComponentBase {
  /**
   * Set the object's initial state.
   *
   * @constructor
   */
  constructor() {
    super('system-messages');
  }

  /**
   * Add the button behaviors.
   */
  init() {
    this.items.forEach(message => {
      const closeButton = message.querySelector('.messages__close');
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          message.remove();
        });
      }
    });
  }
}
